// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    font-family: 'Roboto', sans-serif;
    background-color: #eee;
    font-size: 14px;
}


.wrapper {
    flex-grow: 1;
    height: 100%;
}

.node-designer a {
    color: yellow;
}

.text-updater-node-root {
    border-color: #784be8;
}

.ac-anchor {
    color: yellow;
}

/*.context-menu {
    position: absolute;
    width: 200px;
    height: auto;
    background-color: #fff;
    box-shadow: 0 12px 15px 0 rgba(0, 0, 0, 0.24);
    color: #333;
    padding: 5px 0px;
    border-radius: 5px;
}*/


.context {
    font-size: 1.1em;
    position: absolute;
    width: 200px;
    height: auto;
    padding: 5px 0px;
    border-radius: 5px;
    top: 10px;
    left: 10px;
    background-color: #fff;
    box-shadow: 0 12px 15px 0 rgba(0, 0, 0, 0.24);
    color: black;
}

    .context .context_item {
        height: 32px;
        line-height: 32px;
        cursor: pointer;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }

        .context .context_item:hover {
            background-color: #ddd;
        }

        .context .context_item .inner_item {
            margin: 0px 10px;
        }

            .context .context_item .inner_item i {
                margin: 0 5px 0 0;
                font-weight: bold;
            }

    .context .context_hr {
        height: 1px;
        border-top: 1px solid #bbb;
        margin: 3px 10px;
    }

.custom-node {
    min-width: 150px;
    background-color: white;
    display: flex;
    flex-direction: column;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.custom-node-header {
    flex-grow: 1;
    padding: 8px 24px;
    margin-bottom: 8px;
}

.custom-node-subheader {
    flex-grow: 1;
    padding: 8px;
    background: #eee;
    color: black
}

.custom-node-content {
    flex-grow: 1;
    padding: 0 8px 8px 8px;
}`, "",{"version":3,"sources":["webpack://./src/features/chatbot/components/designer/node-designer.css"],"names":[],"mappings":"AAEA;IACI,iCAAiC;IACjC,sBAAsB;IACtB,eAAe;AACnB;;;AAGA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;;;;;;;;;EASE;;;AAGF;IACI,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,sBAAsB;IACtB,6CAA6C;IAC7C,YAAY;AAChB;;IAEI;QACI,YAAY;QACZ,iBAAiB;QACjB,eAAe;QACf,uBAAuB;QACvB,gBAAgB;QAChB,mBAAmB;IACvB;;QAEI;YACI,sBAAsB;QAC1B;;QAEA;YACI,gBAAgB;QACpB;;YAEI;gBACI,iBAAiB;gBACjB,iBAAiB;YACrB;;IAER;QACI,WAAW;QACX,0BAA0B;QAC1B,gBAAgB;IACpB;;AAEJ;IACI,gBAAgB;IAChB,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,wEAAwE;AAC5E;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB;AACJ;;AAEA;IACI,YAAY;IACZ,sBAAsB;AAC1B","sourcesContent":["@import url(https://fonts.googleapis.com/css?family=Roboto);\n\nbody {\n    font-family: 'Roboto', sans-serif;\n    background-color: #eee;\n    font-size: 14px;\n}\n\n\n.wrapper {\n    flex-grow: 1;\n    height: 100%;\n}\n\n.node-designer a {\n    color: yellow;\n}\n\n.text-updater-node-root {\n    border-color: #784be8;\n}\n\n.ac-anchor {\n    color: yellow;\n}\n\n/*.context-menu {\n    position: absolute;\n    width: 200px;\n    height: auto;\n    background-color: #fff;\n    box-shadow: 0 12px 15px 0 rgba(0, 0, 0, 0.24);\n    color: #333;\n    padding: 5px 0px;\n    border-radius: 5px;\n}*/\n\n\n.context {\n    font-size: 1.1em;\n    position: absolute;\n    width: 200px;\n    height: auto;\n    padding: 5px 0px;\n    border-radius: 5px;\n    top: 10px;\n    left: 10px;\n    background-color: #fff;\n    box-shadow: 0 12px 15px 0 rgba(0, 0, 0, 0.24);\n    color: black;\n}\n\n    .context .context_item {\n        height: 32px;\n        line-height: 32px;\n        cursor: pointer;\n        text-overflow: ellipsis;\n        overflow: hidden;\n        white-space: nowrap;\n    }\n\n        .context .context_item:hover {\n            background-color: #ddd;\n        }\n\n        .context .context_item .inner_item {\n            margin: 0px 10px;\n        }\n\n            .context .context_item .inner_item i {\n                margin: 0 5px 0 0;\n                font-weight: bold;\n            }\n\n    .context .context_hr {\n        height: 1px;\n        border-top: 1px solid #bbb;\n        margin: 3px 10px;\n    }\n\n.custom-node {\n    min-width: 150px;\n    background-color: white;\n    display: flex;\n    flex-direction: column;\n    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);\n}\n\n.custom-node-header {\n    flex-grow: 1;\n    padding: 8px 24px;\n    margin-bottom: 8px;\n}\n\n.custom-node-subheader {\n    flex-grow: 1;\n    padding: 8px;\n    background: #eee;\n    color: black\n}\n\n.custom-node-content {\n    flex-grow: 1;\n    padding: 0 8px 8px 8px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
